/** ***********
*
* <dev-tools.module.ts v1.0>
*
* Copyright (c) 2023 AIRBUS OPERATIONS
*
* Contributors:
*  PEREIRA Thomas [SOPRA STERIA] [thomas.pereira@soprasteria.com]
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*  pranshushrivastav [pranshu.shrivastav@soprasteria.com]
*
 * All rights reserved.
**************/

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppMaterialModule } from '../../material.modules';
import { OrderbyModule } from '../shared/orderby/orderby.module';
import { DevToolsComponent } from './dev-tools.component';
import { DialogGenerateEventsComponent } from './dialog/dialog-generate-events/dialog-generate-events.component';
import { DialogGeneratePlanningsComponent } from './dialog/dialog-generate-plannings/dialog-generate-plannings';
import { DialogGeneratePlanningsLineComponent } from './dialog/dialog-generate-planning-line/dialog-generate-plannings-line.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { devEnvironmentGuard } from 'src/app/auth/dev-environment.guard';
import { hasRightGuard } from 'src/app/auth/has-right.guard';

@NgModule({
    declarations: [
      DevToolsComponent,
      DialogGenerateEventsComponent,
      DialogGeneratePlanningsComponent,
      DialogGeneratePlanningsLineComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        OrderbyModule,
        SharedModule,
        TranslateModule.forChild({ extend: true }),
        AppMaterialModule,
        RouterModule.forChild([
            {
                path: '',
                component: DevToolsComponent,
                canActivate: [hasRightGuard, devEnvironmentGuard]
            },
        ]),
    ],
})
export class DevToolsModule { }
